/**
 * Безопасный доступ к localStorage.
 *
 * В приватном режиме и при переполнении квоты любое обращение бросает.
 * Приложение обязано работать и там — просто без сохранения между
 * запусками. Поэтому все операции глотают ошибку, а не падают.
 */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw) as T;
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* приватный режим или нет места */
  }
}

export function readRaw(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeRaw(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* см. выше */
  }
}
